import CrudCustom from '../../../libs/custom/CrudCustom';

let TransaksiAktivaTetapService = new CrudCustom('/transaksi-aktiva-tetaps');
export default TransaksiAktivaTetapService;
